import { PermissaoService } from './permissao.service';
import { BehaviorSubject } from 'rxjs';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SideMenuService {
  menuItems: Array<any>;

  miniMenu = false;
  navToggled = false;
  subNavToggled = false;

  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2,
    private permissaoService:PermissaoService) {
    this.renderer = rendererFactory.createRenderer(null, null);

    const menuItems = [
      { nome: 'Principal', path: '/home', icon: 'fa fa-home' },
      // { nome: 'Cadastrar Tipo de Bens', path: '/tipoDeBem', icon: 'fa fa-gears' },
      // { nome: 'Cadastrar Unidade Operacional',path: '/cadastrar-localizacao',
      //   icon: 'bi bi-geo-alt',
      // },
      // { nome: 'Cadastro de bens', path: '/cadastrarBem', icon: 'fa fa-desktop' },
      // {
      //   nome: 'Alteração de Cautela',
      //   path: '/liberar-bens',
      //   icon: 'bi bi-clipboard-check',
      // },
      // { 
      //  nome: 'Aprovação de gestor', 
      //   path: '/tela-aprov-gestor', 
      //   icon: 'fa fa-building' 
      // },
       
      // {
      //   nome: 'Tela de Recebimento',
      //   path: '/tela-de-receber',
      //   icon: 'fa fa-list-alt',
      // },
      // {
      //   nome: 'Historico',
      //   path: '/historico',
      //   icon: 'fa fa-drivers-license-o',
      // },
      // {
      //   nome: 'Relatórios',
      //   path: '/relatorio',
      //   icon: 'fa fa-list-alt',
      // },
      // {
      //   nome: 'Minha Cautela',
      //   path: '/meu-bem',
      //   icon: 'fa fa-list-alt',
      // },
      // {
      //   nome: 'Inconsistencia do Usuario',
      //   path: '/inconsistencia-user',
      //   icon: 'bi bi-clipboard-data',
      // },
      // {
      //   nome: 'Tratamento de inconsistencia',
      //   path: '/lista-inconsistencia',
      //   icon: 'fa fa-list-alt',
      // },
      // {
      //   nome: 'Cautela de Grupos',
      //   path: '/grupo-cautela',
      //   icon: 'fa fa-users',
      // },
      // {
      //   nome: 'Recebimento de Grupos',
      //   path: '/grupo-recebimento',
      //   icon: 'fa fa-users',
      // },
      // {
      //   nome: 'Alteração de cautela do grupo',
      //   path: '/grupo-alterar-cautela',
      //   icon: 'fa fa-users',
      // },
    ];

    this.menuItems = menuItems;
    this.carregaPermissoes(this.menuItems);
  }
  carregaPermissoes(menu: Array<any>): void {
    this.menuItems = menu;

    const currentUser = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser') || '{}'));

    this.permissaoService.getBy_SiglaMatricula('PATRIMONIO', currentUser.value.cD_MATRICULA).subscribe(
      (permissoes) => {
        //console.log/permissoes);
        for (const perm of permissoes) {
          if (perm.FL_FUNCIONALIDADE_ATIVO) {
            this.menuItems.push({ nome: perm.DS_FUNCIONALIDADE, path: perm.DS_LINK, icon: perm.DS_IMAGEM });
          }
        }
      }
    );
  }
  public changeMenu() {
    this.miniMenu = !this.miniMenu;

    if (this.miniMenu) {
      this.renderer.setAttribute(document.body, 'class', 'sidebar-mini');
    } else {
      this.renderer.setAttribute(document.body, 'class', '');
    }
  }

  public navToggle() {
    this.navToggled = !this.navToggled;
    const elementHtml = document.getElementsByTagName('html');
    const elementIcon = document.getElementsByClassName('navbar-toggle');

    if (this.navToggled) {
      elementHtml[0].className = 'nav-open';
      elementIcon[0].className = 'navbar-toggle toggled';
    } else {
      elementHtml[0].className = '';
      elementIcon[0].className = 'navbar-toggle';
    }
  }

  public optionsToggle() {
    this.subNavToggled = !this.subNavToggled;
    const elementNav: HTMLElement | null =
      document.getElementById('elementNav');
    const elementButton = document.getElementById('elementButton');
    const elementNavigation = document.getElementById('elementNavigation');

    // if (this.subNavToggled) {
    //   elementNav.className =
    //     'navbar navbar-expand-lg navbar-absolute fixed-top bg-white';
    //   elementButton.className = 'navbar-toggler';
    //   elementNavigation.className =
    //     'navbar-collapse justify-content-end collapse show';
    // } else {
    //   elementNav.className | null =
    //     'navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent';
    //   elementButton.className = 'navbar-toggler collapsed';
    //   elementNavigation.className =
    //     'navbar-collapse justify-content-end collapse';
    // }
  }
}
